import React from 'react';
import { ArrowRightLong } from '../../ui/icons/classic/regular';

export default function AutocompleteSeeAll({ title, url }: {
  title: string;
  url: string;
}) {
  return (
    <a
      href={url}
      className="btn btn-outline-dark btn-arrow mt-4"
      tabIndex={0}
    >
      {title}
      <ArrowRightLong />
    </a>
  );
}
